/** Navigation secondaire des Paramètres. */
import { SETTINGS_NAV, type SettingsNavId } from "./nav";

type SettingsNavProps = {
  current: SettingsNavId;
  onSelect: (id: SettingsNavId) => void;
};

export function SettingsNav({ current, onSelect }: SettingsNavProps) {
  return (
    <nav className="fx-set-nav" aria-label="Paramètres">
      {SETTINGS_NAV.map((item) => (
        <button
          key={item.id}
          type="button"
          className={item.id === current ? "is-on" : ""}
          disabled={!item.ready}
          aria-current={item.id === current ? "page" : undefined}
          title={item.ready ? item.label : `${item.label} — bientôt`}
          onClick={() => {
            if (item.ready) onSelect(item.id);
          }}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
}
